export const MessageToSign = '98d22e0fedbc823b6690f6ca55eeecc2'
export const EncodedMessage = new TextEncoder().encode(MessageToSign)
